
const updateAtBat = (state = {}, action = {}) => {
    const {
        type = null,
        datasource,
        data = {}
    } = action;
    if (type === 'dataEngine_update_response') {
        if (datasource === 'gumbo') {
            const {
                metaData = {},
                gameData: {
                    game: {
                        season
                    } = {},
                    datetime: {
                        officialDate
                    } = {}
                } ={},
                gamePk,
                liveData: {
                    boxscore: {
                        teams = {}
                    } ={},
                    plays: {
                        allPlays = [],
                    } = {}
                } = {},
            } = data;

            return {
                ...state,
                teams,
                allPlays,
                gamePk,
                season,
                officialDate,
                game: data
            };
        }
        if (datasource === 'playMetrics') {
            const {
                allPlayMetrics = {}
            } = action.data;
            return {
                ...state,
                allPlayMetrics
            }
        }
    }
    return state;
};

export default updateAtBat;
